// apps/client/src/game/testFinders/nature.ts (M1-T15) — `__wt.find('shell')`: your unclaimed shell nearest `near`;
// `__wt.find('fruitTree')`: the nearest tree that shows fruit for you (its tile centre).
import type { TreeState, Vec2 } from '@whiskerton/shared';
import type { TestFinder } from '../testHooks';
import { objectsOf } from '../../net/handlers/nature';
import { useGame } from '../../state/store';
import { treeVisual } from '../../world/objects/tree';

const nearest = <T extends { x: number; y: number }>(list: readonly T[], near: Vec2 | null): T | null =>
  [...list].sort((a, b) => (near ? Math.hypot(a.x - near.x, a.y - near.y) - Math.hypot(b.x - near.x, b.y - near.y) : 0))[0] ?? null;

export const finders: readonly TestFinder[] = [
  { kind: 'shell', find: (_g, near) => nearest((useGame.getState().you?.yields.shells ?? []).map((s) => ({ id: s.id, x: s.x, y: s.y })), near) },
  { kind: 'fruitTree', find: (g, near) => {
    const you = useGame.getState().you;
    if (!you) return null;
    const now = g.now();
    const trees = objectsOf(g).filter((o) => o.kind === 'tree' && treeVisual(o.state as TreeState, you.harvests[o.id] ?? null, now).fruitVisible);
    return nearest(trees.map((o) => ({ id: o.id as string, x: o.x + 0.5, y: o.y + 0.5 })), near);
  } },
];
